import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";

const CURRICULUM = [
  "Introduction to AI and Machine Learning",
  "Supervised and Unsupervised Learning",
  "Neural Networks and Deep Learning (CNN, RNN)",
  "Natural Language Processing (NLP)",
  "Computer Vision with OpenCV",
  "Projects: AI Chatbot, Image Recognition, Sentiment Analysis",
  "Tools: Python, Pandas, NumPy, TensorFlow, Scikit-learn",
];

const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training — 6 Weeks",             desc: "Intensive hands-on training with expert mentors." },
  { title: "Mini Projects",                  desc: "Apply concepts through guided mini-projects." },
  { title: "Major AI Project",               desc: "Build a real-world AI application end-to-end." },
  { title: "Assessment & Certification",     desc: "Industry-recognised certification on completion." },
  { title: "Resume & Interview Prep",        desc: "1:1 career coaching and mock interview sessions." },
];

const ArtificialIntelligence = () => (
  <CourseDetailTemplate
    title="Artificial Intelligence Course"
    description="Build your career in Artificial Intelligence. Master core AI concepts, machine learning algorithms, natural language processing, and computer vision. Equip yourself to develop innovative, cutting-edge AI applications."
    curriculum={CURRICULUM}
    structure={STRUCTURE}
    tags={["Python", "TensorFlow", "NLP", "Computer Vision", "Deep Learning"]}
    programName="Artificial Intelligence Course"
  />
);

export default ArtificialIntelligence;
